module.exports = __webpack_public_path__ + "static/logo_sm-aedae0b93504d7c1bc651305951cafdd.png";